import { useState, useEffect } from 'react';
import { Table } from 'react-bootstrap';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';

const ProfileTable = ({ username, email }) => {
    return (
        <div>
            <h4 className="my-4">Your Profile</h4>
            <Table striped bordered hover className="text-left">
                <tbody>
                    <tr>
                        <td>User Name</td>
                        <td>{username}</td>
                    </tr>
                    {email != '' && (
                        <tr>
                            <td>Email</td>
                            <td>{email}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default ProfileTable;
